import { Directive, Input, HostListener } from '@angular/core';

/**
 * Generated class for the MaxLengthDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[max-length]', // Attribute selector
  standalone: true
})
export class MaxLengthDirective {
  @Input('max-length') maxLength;
  constructor() {
  }

  //HostListener decorator handle event handlers for input (onKeyPress)
  @HostListener('keypress', ['$event'])
  onkeypress(ev) {
    const limit = +this.maxLength; //convert to number
    // once it reaches the limit set, stop propgating event.
    if (ev.target.value.length === limit) {
      ev.preventDefault();
    }
  }
}
